import React, { useState, useEffect, Fragment } from 'react';
import Traductor from '../Traductor';
import { delegate } from 'tippy.js';
import '../../css/components/dealerReceptor/modalTakeDecision.css';
import { formatPrice } from '../../js/components/shared/vehicleFunctions';
import {
    isAppleDeviceOrNavegatorForDates,
} from '../../Functions';

function ModalTakeDecision({ options, closeModal, EndDate, importeIncentivo,importeVMG,importeDaños,AutoCredit}) {
    const t = new Traductor();

    const printActionButtons = () => {
        let actions = options.possibleActions;
        let buttons = [];
        if (actions.length > 0) {
            actions.map(action => {
                buttons.push(
                    <label
                        key={'button-group-item' + action}
                        className="c-button-group__item"
                        htmlFor={'button-group-item' + action}
                    >
                        <input
                            className="c-button-group__input"
                            type="radio"
                            name={'button-group-item' + action}
                            id={'button-group-item' + action}
                            onClick={() => closeModal(action)}
                        />
                        <span
                            className={
                                action == 'Buy'
                                    ? 'c-btn c-btn--full'
                                    : 'c-button-group__label'
                            }
                        >
                            {t.getTraduction(action)}
                        </span>
                    </label>
                );
            });
        }

        return (
            <div
                className={
                    'c-button-group c-button-group--auto' +
                    (actions.length == 2 ? 'two-buttons' : '')
                }
            >
                {buttons}
            </div>
        );
    };

    const printHelpBuyInfo = () => {
        var date= new Date(isAppleDeviceOrNavegatorForDates(EndDate)).toLocaleDateString('en-GB');
        var ayuda="";
        if(options.possibleActions.length==2)
        ayuda="<ul style='font-size:13px'><li> Tenéis hasta el día " + date + " para tomar la decisión de adquirir el vehículo o venderlo a VW Renting</li><li> Recordad que en caso que lo queráis vender a VW Renting, tendréis que hacer llegar la documentación original del vehículo a gestoría en un plazo máximo de 10 días</li><li> Si a fecha " + date + " no se ha registrado ninguna decisión, el vehículo os será adjudicado de forma automática sin posibilidad de posterior venta a VW Renting</li></ul>";
        if(options.possibleActions.length==1)
        ayuda="<ul style='font-size:13px'><li> Tenéis hasta el día " + date + " para tomar la decisión de adquirir el vehículo.</li><li> Si a fecha " + date + " no se ha registrado ninguna decisión, el vehículo os será adjudicado de forma automática.</li></ul>";
        


        return (
            <Fragment>
                <button
                    type="button"
                    style={{ marginLeft: '10px' }}
                    className="c-icon c-info-icon js-tooltip c-icon--[semantic-info] c-info-icon-tooltip"
                    data-tippy-content={ayuda}
                    data-tippy-placement="right"
                    tabIndex="-1"
                ></button>
            </Fragment>
        );
    };

    const closeThisModal = () => {
        closeModal(true);
    };

    return (
        <div className="c-modal" aria-hidden="false" id="modal-take-decision">
            <div
                className="c-modal__overlay  js-modal-close"
                tabIndex="-1"
            ></div>
            <div
                className="c-modal__wrapper"
                role="dialog"
                aria-labelledby="modal-take-decision-title"
            >
                <header className="c-modal__header">
                    <button
                        className="c-modal__close-btn  js-modal-close"
                        type="button"
                        aria-label="Cerrar modal."
                        onClick={closeThisModal}
                    ></button>
                    <div className="c-modal__title__wrapper">
                        <h1
                            className="c-modal__title"
                            id="modal-take-decision-title"
                        >
                            {' '}
                            {t.getTraduction('ModalTakeDecision_title')}
                            {options.possibleActions[0] == "BuyAutoCredit" ? (printHelpBuyInfo() ):null}
                        </h1>
                    </div>
                </header>
                <div
                    className="c-modal__content u-mt u-mb u-pt@xl u-pt u-pt-none@s u-pb-large u-pb-none@s"
                    role="document"
                >
                    {AutoCredit && AutoCredit === 1 ? (
                    <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                    <p className="u-text-disabled u-mb-xsmall rema-text-overflow--ellipsis">
                                                    <span className="u-text-disabled">
                                                        {t.getTraduction('VehiclePrice')}
                                                    </span>
                                                </p>
                                                <p className="u-mb-xsmall">{formatPrice(importeVMG)}</p>
                                                <p className="u-text-disabled u-mb-xsmall rema-text-overflow--ellipsis">
                                                    <span className="u-text-disabled">
                                                        {t.getTraduction('DamagesToReturn')}
                                                    </span>
                                                </p>
                                                <p className="u-mb-xsmall">{formatPrice(importeDaños)}</p>
                                            </div>
                                            ) : null}
                    {importeIncentivo && importeIncentivo > 1 ? (
                        <p className="u-mb u-text-success">
                            {t.getTraduction('ModalTakeDecision_incentive_prefix')}
                            <strong>{new Intl.NumberFormat('ca', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(importeIncentivo)}</strong>
                            {' '}<small style={{ fontSize: '0.8em' }}>(iva incluido)</small>
                            {t.getTraduction('ModalTakeDecision_incentive_suffix')}
                        </p>
                    ) : null}
                    {printActionButtons()}
                </div>
            </div>
        </div>
    );
}

export default ModalTakeDecision;
